import React, { useEffect, useState } from "react";
import { menuArr } from "../../data/constant"
import { HomeIcon,SoundIcon,InfoIcon,SoundOffIcon } from "../../data/menu_svg"
import IconGenerator from "../Util/IconGenerator";
import MenuList from "./menulist";
import $ from "jquery"

const NavbarSidebarComponent = React.memo(function NavbarSidebarComponent({sidebarToggle,changeRender360Map,
    setGuidedView,redirectToHome,setSpeaker,speaker,setModalPopupContent,isSmeUser,handlehideSidebar}) {


    const [soundtitle , setSoundTitle] = useState('Sound Off')

    const [thermatruArialCurrent,setThermatruArialViewCurrent] = useState("thermatru_arial")
    const [fyponArialCurrent,setFyponArialViewCurrent] = useState("fypon_arial")

    useEffect(() => {

        if(speaker) {
            setSoundTitle('Sound On')
        }else{
            setSoundTitle('Sound Off')

        }
    },[speaker])

    const uiChangeFunc = (val) => {

        if(val === "Info") {
            setModalPopupContent("web_info")
            // $("#infomodal").modal('show')
            // $(".navigation-container").hide();
            // $(".nav-header-div").hide();
        }
        else if(val === "Home") {
            redirectToHome()
        }
        else if(val === "Sound Off") {
            setSpeaker()
            setSoundTitle('Sound On')
        }
        else if(val === "Sound On") {
            setSpeaker()
            setSoundTitle('Sound Off')
        }
    }
    const collapseNav = (e,key) => {
        

        document.querySelectorAll('.mainmenu li a').forEach(element => {
            element.style.color = "#4e4e4e"
        })


        if(key === "Guide") {

            setGuidedView('show')
            e.target.style.color = '#E91E23'

        }
        else if(key === "sme_add_participant") {

            setModalPopupContent(key)

        }
        else if(key === "media") {

            changeRender360Map('prmedia')
            e.target.style.color = '#E91E23'

        }
        else if(key === "success") {

            changeRender360Map('thermatru_key_success')
            e.target.style.color = '#E91E23'

        }
        else{

            $(".colaps").removeClass('active_arrow')
            var element = e.target.nextSibling

            if(element.classList.contains('collapsed')){
    
                element.classList.remove("collapsed")
                e.target.style.color = "#4e4e4e"
    
            }else{
    
            
                document.querySelectorAll('.submenu').forEach(element => {
                    element.previousSibling.style.color = "#4e4e4e"
                    element.classList.remove("collapsed")
                })
    
                e.target.style.color = e.target.dataset.colortype
                element.classList.add("collapsed")
                e.target.classList.add("active_arrow")

           
            }

            if(key === "therma") {
                let changableArilViewName = ""
                if(thermatruArialCurrent === "thermatru_arial_nav"){
                    changableArilViewName = "thermatru_arial"
                }else{
                    changableArilViewName = "thermatru_arial_nav"

                }
                
                changeRender360Map(changableArilViewName)
                setThermatruArialViewCurrent(changableArilViewName)



            }

            if(key === "fypon") {

                let changableArilViewName = ""
                if(fyponArialCurrent === "fypon_arial_nav"){
                    changableArilViewName = "fypon_arial"
                }else{
                    changableArilViewName = "fypon_arial_nav"

                }
                


                changeRender360Map(changableArilViewName)
                setFyponArialViewCurrent(changableArilViewName)
            }
    
        }



    }

    const sidebarhide = () => {

        handlehideSidebar()
    }

    
    return(
        <div className="navigation-container "  style={sidebarToggle ? { display : 'block'} : {display : 'none'} }>
                                
            <img src="images/nav_close.png" alt="" className="menu_close_icon" onClick={sidebarhide}></img>

            <nav className="navigation " >
                <div className="menu-tag">
                    <img src="images/menu(1).png" alt="" />
                    <span>Menu</span>
                </div>
                <ul className="mainmenu">
                    {
                        menuArr.map(item => {

                            if(item.key === 'sme') {
                                if(isSmeUser){
                                    return <MenuList item={item} key={item.label} 
                                            collapseNav={collapseNav} 
                                            setModalPopupContent={setModalPopupContent} 
                                            changeRender360Map={changeRender360Map} />
                                }
                    
                            }else{
                                return <MenuList item={item} key={item.label} 
                                            collapseNav={collapseNav} 
                                            setModalPopupContent={setModalPopupContent} 
                                            changeRender360Map={changeRender360Map} />
                            }
                      
                        })
                    }

                </ul>
            
            </nav>

            <div className="nav-header-div nav_tag_icon text-center">

                <IconGenerator iconTitle="Home" IconSvg={HomeIcon} uiChangeFunc={uiChangeFunc} />
                {
                    soundtitle === "Sound Off" &&  <IconGenerator iconTitle={soundtitle} IconSvg={SoundOffIcon}  uiChangeFunc={uiChangeFunc}/>

                }

                {
                    soundtitle === "Sound On" &&  <IconGenerator iconTitle={soundtitle} IconSvg={SoundIcon}  uiChangeFunc={uiChangeFunc}/>  

                }
                
                <IconGenerator iconTitle="Info" IconSvg={InfoIcon} uiChangeFunc={uiChangeFunc}/>

            </div>
        </div>
    )


});


export default NavbarSidebarComponent;